import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { datosAval } from "../../interfaces/solicitudes";
import { ActivatedRoute, Router } from "@angular/router";
import { SolicitudesService } from "../../servicios/solicitudes.service";

@Component({
	selector: "app-contrato",
	templateUrl: "./contrato.component.html",
	styleUrls: ["./contrato.component.css"],
})
export class ContratoComponent implements OnInit {
	moduleName = "Gestión de Solicitudes";
	componentName = "Contrato";
	@Input() listadoDatosAvales: any;
	tramiteID: number;
	ContratoFormulario: FormGroup;
	visibleSeccionContratoPagare: boolean = false;
	cargadoContrato: boolean = false;
	cargadoPagare: boolean = false;
	blobDatosContrato: any;
	blobDatosPagare: any;

	base64DatosPrueba: string =
		"JVBERi0xLjMKJf////8KNyAwIG9iago8PAovVHlwZSAvUGFnZQovUGFyZW50IDEgMCBSCi9NZWRpYUJveCBbMCAwIDYxMiA3OTJdCi9Db250ZW50cyA1IDAgUgovUmVzb3VyY2VzIDYgMCBSCj4+CmVuZG9iago2IDAgb2JqCjw8Ci9Qcm9jU2V0IFsvUERGIC9UZXh0IC9JbWFnZUIgL0ltYWdlQyAvSW1hZ2VJXQovRm9udCA8PAovRjIgOCAwIFIKPj4KPj4KZW5kb2JqCjUgMCBvYmoKPDwKL0xlbmd0aCA5MgovRmlsdGVyIC9GbGF0ZURlY29kZQo+PgpzdHJlYW0KeJwzVDAAQl1DIGFuaaSQnMtVyGWIIeYUAhU0VDA3UjCzsNQzNFcIyeXSdzNSMDRQCEnjirYxMTEzNUsxSzMyMDcwMzQzNzM1SrVTMIhVCPHicg3hCuQCAGTCFcEKZW5kc3RyZWFtCmVuZG9iagoxMCAwIG9iagooUERGS2l0KQplbmRvYmoKMTEgMCBvYmoKKFBERktpdCkKZW5kb2JqCjEyIDAgb2JqCihEOjIwMjAwOTA0MjIzNzM1WikKZW5kb2JqCjkgMCBvYmoKPDwKL1Byb2R1Y2VyIDEwIDAgUgovQ3JlYXRvciAxMSAwIFIKL0NyZWF0aW9uRGF0ZSAxMiAwIFIKPj4KZW5kb2JqCjggMCBvYmoKPDwKL1R5cGUgL0ZvbnQKL0Jhc2VGb250IC9UaW1lcy1Sb21hbgovU3VidHlwZSAvVHlwZTEKL0VuY29kaW5nIC9XaW5BbnNpRW5jb2RpbmcKPj4KZW5kb2JqCjQgMCBvYmoKPDwKPj4KZW5kb2JqCjMgMCBvYmoKPDwKL1R5cGUgL0NhdGFsb2cKL1BhZ2VzIDEgMCBSCi9OYW1lcyAyIDAgUgo+PgplbmRvYmoKMSAwIG9iago8PAovVHlwZSAvUGFnZXMKL0NvdW50IDEKL0tpZHMgWzcgMCBSXQo+PgplbmRvYmoKMiAwIG9iago8PAovRGVzdHMgPDwKICAvTmFtZXMgWwpdCj4+Cj4+CmVuZG9iagp4cmVmCjAgMTMKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwNzE0IDAwMDAwIG4gCjAwMDAwMDA3NzEgMDAwMDAgbiAKMDAwMDAwMDY1MiAwMDAwMCBuIAowMDAwMDAwNjMxIDAwMDAwIG4gCjAwMDAwMDAyMDggMDAwMDAgbiAKMDAwMDAwMDExOSAwMDAwMCBuIAowMDAwMDAwMDE1IDAwMDAwIG4gCjAwMDAwMDA1MzIgMDAwMDAgbiAKMDAwMDAwMDQ1NyAwMDAwMCBuIAowMDAwMDAwMzcxIDAwMDAwIG4gCjAwMDAwMDAzOTYgMDAwMDAgbiAKMDAwMDAwMDQyMSAwMDAwMCBuIAp0cmFpbGVyCjw8Ci9TaXplIDEzCi9Sb290IDMgMCBSCi9JbmZvIDkgMCBSCj4+CnN0YXJ0eHJlZgo4MTgKJSVFT0YK";

	constructor(
		private formBuilder: FormBuilder,
		private router: ActivatedRoute,
		private serviciosSolicitud: SolicitudesService
	) {
		this.obtenerID();
		this.crearFormulario();
		this.blobDatosContrato = this.b64toBlob(
			this.base64DatosPrueba,
			"application/pdf"
		);
		this.blobDatosPagare =
			"http://www.jtech.ua.es/dadm/restringido/java/sesion01-apuntes.pdf";
	}

	ngOnInit(): void {}

	obtenerID() {
		this.router.paramMap.subscribe((params) => {
			if (params.has("id")) {
				this.tramiteID = +params.get("id");

				this.obtenerInformacionSolicitud();
			}
		});
	}

	obtenerInformacionSolicitud() {
		this.serviciosSolicitud
			.obtenersolicitudId(this.tramiteID)
			.subscribe((res) => {
				if (res) {
					console.log(res);
					this.listadoDatosAvales = res.ListaDatosAval;
				}
			});
	}

	b64toBlob(b64Data, contentType = "", sliceSize = 512) {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (
			let offset = 0;
			offset < byteCharacters.length;
			offset += sliceSize
		) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	}

	crearFormulario() {
		this.ContratoFormulario = this.formBuilder.group({
			Aval_ID: [0, ""],
		});
	}

	avalOnChangeSeleccion(evento) {
		if (evento.value !== null && evento.value !== undefined) {
			this.visibleSeccionContratoPagare = true;
		} else {
			this.visibleSeccionContratoPagare = false;
		}
	}

	cargarArchivoContrato() {
		console.log("Cargar contrato");
		this.cargadoContrato = true;
	}

	cargarArchivoPagare() {
		console.log("Cargar Pagare");
		this.cargadoPagare = true;
	}

	validarContrato() {
		console.log(this.ContratoFormulario);
	}
}
